module.exports = __webpack_public_path__ + "static/media/Atlantique.6cd9e466.png";